import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import snakeCase from 'lodash/snakeCase';

import {
  getFrequencyCategoricalParametersName,
  getLevelsRowFrequencyDatasetByName
} from 'store/dataset';

import { getObservedCountsDataSet } from 'store/form/inferentialStatistics/chiSquare/selectors';
import { getExpectedCounts } from 'store/form/inferentialStatistics/pairedT/selectors';
import { setExpectedCountValue } from 'store/form/inferentialStatistics/chiSquare/actions';

import { round6 } from 'utilities/math';

import ChiSquareComponent from './Component';

const ChiSquareContainer = props => {
  const getOptionsObservedCounts = () => {
    const {
      parameter,
      frequencyValueNames
    } = props;
    if (frequencyValueNames.length > 1) {
      return frequencyValueNames.map(name => ({
        value: name,
        label: name,
        text: name
      }));
    }
    return [{ value: parameter, label: parameter, text: parameter }];
  };

  return (
    <ChiSquareComponent
      optionsObservedCounts={getOptionsObservedCounts()}
      {...props}
    />
  );
};

ChiSquareContainer.propTypes = {
  parameter: PropTypes.string.isRequired,
  frequencyValueNames: PropTypes.array.isRequired,
  isValidationChiSquareError: PropTypes.bool.isRequired,
  onExpectedCountsTypeChange: PropTypes.func.isRequired,
  setValidationChiSquareError: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const frequencyValueNames = getFrequencyCategoricalParametersName(state);

  const { observedCounts } = state.form.INFERENTIAL_STATISTICS.values.chiSquare;
  const currentExpectedCountValues =
    state.form.INFERENTIAL_STATISTICS.values.chiSquare[observedCounts];

  let calculatedTotalValue = 0;
  for (const key of Object.keys(currentExpectedCountValues)) {
    calculatedTotalValue += parseFloat(currentExpectedCountValues[key]);
  }
  let parameter = '';
  if (frequencyValueNames.length === 1) {
    [parameter] = frequencyValueNames;
  } else {
    parameter = getObservedCountsDataSet(state);
  }

  const {
    levels: parameterLevels,
    totalCount
  } = getLevelsRowFrequencyDatasetByName(state)(parameter);

  return {
    parameter,
    totalCount,
    parameterLevels,
    frequencyValueNames,
    expectedCountRadioValue: getExpectedCounts(state),
    calculatedTotalValue
  };
};

const mapDispatchToProps = {
  onExpectedCountsTypeChange: () => (dispatch, getState) => {
    const state = getState();
    const {
      observedCounts
    } = state.form.INFERENTIAL_STATISTICS.values.chiSquare;
    const currentExpectedCountValues =
      state.form.INFERENTIAL_STATISTICS.values.chiSquare[observedCounts];

    const currentExpectedCountValuesArr = Object.values(
      currentExpectedCountValues
    );
    const isExpectedCountValuesEqual =
      currentExpectedCountValuesArr[0] &&
      currentExpectedCountValuesArr.every(
        value => +currentExpectedCountValuesArr[0] === +value
      );

    if (!isExpectedCountValuesEqual) {
      const {
        levels: parameterLevels,
        totalCount
      } = getLevelsRowFrequencyDatasetByName(state)(observedCounts);
      const proportion = 1 / currentExpectedCountValuesArr.length;
      parameterLevels.forEach(parameter =>
        dispatch(
          setExpectedCountValue(
            observedCounts,
            `level_${snakeCase(parameter.name)}`,
            round6(proportion * totalCount)
          )
        )
      );
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ChiSquareContainer);
